export default __webpack_public_path__ + "static/media/main-background.df92cdee.jpg";